import { connect } from 'react-redux';

import { basketSelectors } from '@store/basket/selectors';
import { NormalizedStore } from '@store/entity/entity.types';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { setJourneyParams, changeJourneyParam } from '@store/yourJourney/actions';
import { RateDetail } from './RateDetail';

const mapStateToProps = (state: NormalizedStore) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  roomIdsInBasket:
    basketSelectors.getBasketDetails(state)?.items?.map((room) => room?.bookable?.ids?.roomId) ||
    [],
});

const mapDispatchToProps = {
  changeJourneyParam,
  setJourneyParams,
};

export const RateContainer: any = connect(mapStateToProps, mapDispatchToProps)(RateDetail);
